import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getProcesosExpedienteByUnidad.php';

export default function getProcesosExpedienteByUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}